import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    selectedCaseMovementType: CustomSingleSelectModel | undefined
    selectedCustomForm: CustomSingleSelectModel | undefined
    selectedCurrencyType: CustomSingleSelectModel | undefined
    selectedFirmTypes: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest: GetBankAccountTransactionMatchDefinitionListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    selectedCaseMovementType: undefined,
    selectedCustomForm: undefined,
    selectedCurrencyType: undefined,
    selectedFirmTypes: [],
    columnFilters: []
}